import React from 'react';
import { RouteObject } from 'react-router-dom';
import loadable from '@loadable/component';

import { ExacareFeature, FeatureFlagService } from '@/utils/featureFlagService';

import { ProtectedRoute } from '../ProtectedRoute';

const AdminHub = loadable(() => import('@/pages/AdminHub')); // prettier-ignore
const AdminHubFacilities = loadable(
  () => import('@/pages/AdminHub/Facilities')
); // prettier-ignore
const AdminHubCommunitySettings = loadable(
  () => import('@/pages/AdminHub/CommunitySettings')
); // prettier-ignore
const AdminHubScreenerSettings = loadable(
  () => import('@/pages/AdminHub/ScreenerSettings')
); // prettier-ignore
const AdminHubScreenerSettingsUsageOverview = loadable(
  () => import('@/pages/AdminHub/ScreenerSettings/UsageOverview')
); // prettier-ignore
const AdminHubScreenerSettingsIntegrations = loadable(
  () => import('@/pages/AdminHub/ScreenerSettings/Integrations')
); // prettier-ignore
const AdminHubScreenerSettingsPayerList = loadable(
  () => import('@/pages/AdminHub/ScreenerSettings/PayerList')
); // prettier-ignore
const AdminHubScreenerSettingsOrganizationStates = loadable(
  () => import('@/pages/AdminHub/ScreenerSettings/OrganizationStates')
); // prettier-ignore
const AdminHubScreenerSettingsApprovedHospitalSources = loadable(
  () => import('@/pages/AdminHub/ScreenerSettings/ApprovedHospitalSources')
); // prettier-ignore
const AdminHubScreenerSettingsDocumentIgnoreList = loadable(
  () => import('@/pages/AdminHub/ScreenerSettings/DocumentIgnoreList')
); // prettier-ignore
const AdminHubScreenerSettingsPayerContract = loadable(
  () =>
    import('@/pages/AdminHub/ScreenerSettings/PayerList/ContractDetails/index')
); // prettier-ignore

export enum AdminHubGeneralRoutes {
  AdminHub = '/:domain/admin-hub',
  AdminHubNotificationPreferences = '/:domain/admin-hub/notification-preferences',
  AdminHubCommunities = '/:domain/admin-hub/communities',
  AdminHubCommunity = '/:domain/admin-hub/community/:facility_id',
  AdminHubScreenerSettings = '/:domain/admin-hub/screener-settings',
  AdminHubScreenerSettingsUsageOverview = '/:domain/admin-hub/screener-settings/usage-overview',
  AdminHubScreenerSettingsIntegrations = '/:domain/admin-hub/screener-settings/integrations',
  AdminHubScreenerSettingsPayerList = '/:domain/admin-hub/screener-settings/payer-list',
  AdminHubScreenerSettingsPayerContract = '/:domain/admin-hub/screener-settings/payer-list/contracts/:contract_id',
  AdminHubScreenerSettingsOrganizationStates = '/:domain/admin-hub/screener-settings/organization-states',
  AdminHubScreenerSettingsApprovedHospitalSources = '/:domain/admin-hub/screener-settings/approved-hospital-sources',
  AdminHubScreenerSettingsDocumentIgnoreList = '/:domain/admin-hub/screener-settings/document-ignore-list'
}

export const getAdminHubGeneralRoutes = (): RouteObject[] => {
  const screenerSettingsChildren: RouteObject[] = [
    {
      index: true,
      element: <AdminHubScreenerSettingsUsageOverview />
    },
    {
      path: AdminHubGeneralRoutes.AdminHubScreenerSettingsUsageOverview,
      element: <AdminHubScreenerSettingsUsageOverview />
    },
    {
      path: AdminHubGeneralRoutes.AdminHubScreenerSettingsIntegrations,
      element: <AdminHubScreenerSettingsIntegrations />
    },

    ...(FeatureFlagService.isEnabled(ExacareFeature.CRM_SCREENER_PAYER_LIST)
      ? [
          {
            path: AdminHubGeneralRoutes.AdminHubScreenerSettingsPayerList,
            element: <AdminHubScreenerSettingsPayerList />
          }
        ]
      : []),
    ...(FeatureFlagService.isEnabled(
      ExacareFeature.CRM_SCREENER_ORGANIZATION_STATES
    )
      ? [
          {
            path: AdminHubGeneralRoutes.AdminHubScreenerSettingsOrganizationStates,
            element: <AdminHubScreenerSettingsOrganizationStates />
          }
        ]
      : []),

    {
      path: AdminHubGeneralRoutes.AdminHubScreenerSettingsApprovedHospitalSources,
      element: <AdminHubScreenerSettingsApprovedHospitalSources />
    },
    {
      path: AdminHubGeneralRoutes.AdminHubScreenerSettingsDocumentIgnoreList,
      element: <AdminHubScreenerSettingsDocumentIgnoreList />
    }
  ];

  return [
    {
      path: AdminHubGeneralRoutes.AdminHub,
      element: <ProtectedRoute component={AdminHub} role="L1" />,
      children: [
        {
          path: AdminHubGeneralRoutes.AdminHubCommunities,
          element: <AdminHubFacilities />
        },
        {
          path: AdminHubGeneralRoutes.AdminHubCommunity,
          element: <AdminHubCommunitySettings />
        },
        {
          path: AdminHubGeneralRoutes.AdminHubScreenerSettings,
          element: <AdminHubScreenerSettings />,
          children: screenerSettingsChildren
        },
        ...(FeatureFlagService.isEnabled(ExacareFeature.CRM_SCREENER_PAYER_LIST)
          ? [
              {
                path: AdminHubGeneralRoutes.AdminHubScreenerSettingsPayerContract,
                element: <AdminHubScreenerSettingsPayerContract />
              }
            ]
          : [])
      ]
    }
  ];
};
